import { render, staticRenderFns } from "./UserGroupGrid.vue?vue&type=template&id=3a14e92f&scoped=true&"
import script from "./UserGroupGrid.vue?vue&type=script&lang=ts&"
export * from "./UserGroupGrid.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupGrid.vue?vue&type=style&index=0&id=3a14e92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14e92f",
  null
  
)

export default component.exports